import React from 'react';
import { ScreenProps } from '@fnol/library/src/lib';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { translations } from '../../lib/consts';
import { Typography } from '@mui/material';
import { common } from '@fnol/library/src/lib/consts';

export const FirstMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward }] = navigator;
    return (
        <>
            <Box sx={{ width: '100%', paddingTop: '15px' }}>
                <Typography>
                    <div style={{ textAlign: 'center' }}>
                        <h2>{translations.INTRO_MESSAGE_1_TITLE}</h2>
                        <h3 style={{ textDecoration: 'underline' }}>{translations.INTRO_MESSAGE_1_SUBTITLE}</h3>
                    </div>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>
                            <b>{translations.INTRO_MESSAGE_1_LINE_1_1}</b>
                            {translations.INTRO_MESSAGE_1_LINE_1_2}
                            <b>{translations.INTRO_MESSAGE_1_LINE_1_3}</b>
                        </li>
                        <li>
                            {translations.INTRO_MESSAGE_1_LINE_2_1}
                            <b>{translations.INTRO_MESSAGE_1_LINE_2_2}</b>
                        </li>
                        <li>
                            <b>{translations.INTRO_MESSAGE_1_LINE_3_1}</b>
                            {translations.INTRO_MESSAGE_1_LINE_3_2}
                        </li>
                        <li>
                            <b>{translations.INTRO_MESSAGE_1_LINE_4}</b>
                        </li>
                        <li>
                            <b>{translations.INTRO_MESSAGE_1_LINE_5_1}</b>
                            {translations.INTRO_MESSAGE_1_LINE_5_2}
                            <a href={translations.INTRO_MESSAGE_1_LINK_1} target="_blank" rel="noreferrer">
                                {translations.INTRO_MESSAGE_1_LINE_5_3}
                            </a>
                            {translations.INTRO_MESSAGE_1_LINE_5_4}
                            <a href={translations.INTRO_MESSAGE_1_LINK_2} target="_blank" rel="noreferrer">
                                {translations.INTRO_MESSAGE_1_LINE_5_5}
                            </a>
                            {translations.INTRO_MESSAGE_1_LINE_5_6}
                        </li>
                    </ul>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '15px' }}>
                <div></div>
                <Button onClickHandler={goForward} label={common.NEXT} />
            </Box>
        </>
    );
};
